import * as Icons from "lucide-react";
import { X, Package } from "lucide-react";

const RARITY_COLOR = { Common: "#9ca3af", Uncommon: "#57d977", Rare: "#4dd0ff", "Ultra-Rare": "#b14dff", Legendary: "#FFB300" };

export function rarityIndex(r) {
  return { Common: 8, Uncommon: 30, Rare: 58, "Ultra-Rare": 82, Legendary: 101 }[r] || 1;
}

// Classic inspect modal: name, thumbnail, rarity index r1..r101, flavor, utility actions
export default function ItemModal({ item, actions = [], onClose }) {
  if (!item) return null;
  const color = RARITY_COLOR[item.rarity] || "#9ca3af";
  const Icon = Icons[item.icon?.replace(/(^|-)([a-z])/g, (_, s, c) => c.toUpperCase())] || Package;
  const rIdx = item.rarity_index || rarityIndex(item.rarity);
  return (
    <div className="fixed inset-0 z-[70] grid place-items-center p-4" data-testid="item-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative panel-glow w-full max-w-sm p-6 pop-in" style={{ boxShadow: `0 0 40px -8px ${color}` }}>
        <button data-testid="item-modal-close" onClick={onClose} className="absolute top-3 right-3 text-muted-foreground hover:text-foreground"><X className="w-5 h-5" /></button>
        <div className="flex items-start gap-4 mb-4">
          <div className="w-20 h-20 rounded-xl grid place-items-center shrink-0" style={{ background: `${color}22`, border: `2px solid ${color}` }}>
            <Icon className="w-10 h-10" style={{ color }} />
          </div>
          <div className="min-w-0 pt-1">
            <h3 className="font-head font-black text-xl leading-tight" data-testid="item-modal-name">{item.name}</h3>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs font-bold px-2 py-0.5 rounded-full" style={{ background: `${color}22`, color }}>{item.rarity}</span>
              <span className="label-cap text-[10px]" data-testid="item-modal-rarity">Rarity r{rIdx}</span>
            </div>
            {item.category && <div className="label-cap text-[9px] mt-1">{item.category}</div>}
          </div>
        </div>
        {item.desc && <p className="text-sm text-muted-foreground italic mb-4 leading-relaxed">"{item.desc}"</p>}
        {actions.length > 0 && (
          <div className="grid grid-cols-2 gap-2" data-testid="item-modal-actions">
            {actions.map((a) => (
              <button key={a.label} data-testid={`item-action-${a.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => { a.onClick(); onClose(); }} disabled={a.disabled}
                className={`text-sm py-2 rounded-[var(--radius)] font-semibold transition-colors ${a.primary ? "bg-primary text-primary-foreground" : "border border-border hover:border-primary hover:text-primary"} ${a.disabled ? "opacity-40" : ""}`}>
                {a.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
